import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  Validators,
  UntypedFormControl,
} from '@angular/forms';
import { ClaimService, ToastMessageService } from '@fitness-force/api';
import { ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { CommmonPipeModule } from '@fitness-force/pipes/common-pipes'
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { DividerModule } from 'primeng/divider';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberComponent } from 'libs/shared/src/lib/components/input-number/input-number.component';
import { BehaviorSubject, interval, debounce } from 'rxjs';

@Component({
  selector: 'fitness-force-staff-permission-template',
  templateUrl: './staff-permission-template.component.html',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StyleClassModule,
    ChipModule,
    CheckboxModule,
    RippleModule,
    StyleClassModule,
    SelectButtonModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    ErrorMsgComponent,
    TranslateModule,
    ErrorMsgComponent,
    InputNumberModule,
    ErrorsComponent,
    SkeletonModule,
    ToggleSwitchModule,
    CardModule,
    TooltipModule,
    CommmonPipeModule,
    InputNumberModule,
    InputNumberComponent
]
})
export class StaffPermissionTemplateComponent implements OnInit, OnChanges {

  @Input('staffPermissionId') staffPermissionId: any;
  @Input('saveForm') saveForm = false;
  @Input('insideDialog') insideDialog = false;
  @Output("formRef") formRef = new EventEmitter<NgForm>()
  @Output("close") close = new EventEmitter<boolean>();
  @Output("modified") modified = new EventEmitter<any>();
  @Output("formChange") formChange = new EventEmitter<boolean>()


  form: NgForm;
  @ViewChild('form') set content(content: NgForm) {
    if (content) {
      this.form = content;
      this.formRef.emit(this.form);
    }
  }
  staffPermissionForm!: UntypedFormGroup;
  isFormSubmitting = false;
  // Loader ..
  loading = new BehaviorSubject<boolean>(false);

  activeStaffPermission!: any;
  showErrorPopup$ = new BehaviorSubject(false);
  errorMessages = [] as any;

  constructor(
    private fb: UntypedFormBuilder,
    private claimService: ClaimService,
    private toastMessageService: ToastMessageService,
    public translate: TranslateService,
    private cd: ChangeDetectorRef,
    ) {
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.preFormData();
  }

  preFormData() {
    if (this.staffPermissionId) {
      this.loading.next(true);
      this.claimService
        .getTemplate(this.staffPermissionId)
        .subscribe({
          next: (res: any) => {
            this.loading.next(false);
            this.activeStaffPermission = res;
            this.initializeForm();
          },
          error: (error: any) => {
            this.loading.next(false);
            this.handleError(error);
          },
        });
    } else {
      this.initializeForm();
    }
  }
  
  initializeForm() {
    this.staffPermissionForm = this.fb.group({
      name: [
        this.staffPermissionId && this.activeStaffPermission.name
          ? this.activeStaffPermission.name
          : "",
        Validators.required
  ],
      description: [
        this.staffPermissionId && this.activeStaffPermission.description
          ? this.activeStaffPermission.description
          : ""
  ],
      can_do_client_profiles: [
        this.staffPermissionId && this.activeStaffPermission.can_do_client_profiles
          ? this.activeStaffPermission.can_do_client_profiles
          : false
  ],
      can_manage_client_profiles: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_client_profiles
          ? this.activeStaffPermission.can_manage_client_profiles
          : false
  ],
      can_admin_client_profiles: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_client_profiles
          ? this.activeStaffPermission.can_admin_client_profiles
          : false
  ],

      can_do_billing: [
        this.staffPermissionId && this.activeStaffPermission.can_do_billing
          ? this.activeStaffPermission.can_do_billing
          : false
  ],
      can_admin_billing: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_billing
          ? this.activeStaffPermission.can_admin_billing
          : false
  ],
      can_manage_membership_basic: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_membership_basic
          ? this.activeStaffPermission.can_manage_membership_basic
          : false
  ],

      can_admin_membership: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_membership
          ? this.activeStaffPermission.can_admin_membership
          : false
  ],
      can_manage_class: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_class
          ? this.activeStaffPermission.can_manage_class
          : false
  ],
      can_admin_class: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_class
          ? this.activeStaffPermission.can_admin_class
          : false
  ],

      can_manage_appointments: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_appointments
          ? this.activeStaffPermission.can_manage_appointments
          : false
  ],
      can_admin_appointments: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_appointments
          ? this.activeStaffPermission.can_admin_appointments
          : false
  ],
      can_do_member_communication: [
        this.staffPermissionId && this.activeStaffPermission.can_do_member_communication
          ? this.activeStaffPermission.can_do_member_communication
          : false
  ],
      can_manage_member_communication: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_member_communication
          ? this.activeStaffPermission.can_manage_member_communication
          : false
  ],

      can_admin_member_communication: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_member_communication
          ? this.activeStaffPermission.can_admin_member_communication
          : false
  ],
      can_do_free_form_manage_member_communication: [
        this.staffPermissionId && this.activeStaffPermission.can_do_free_form_manage_member_communication
          ? this.activeStaffPermission.can_do_free_form_manage_member_communication
          : false
  ],
      can_do_templated_member_communication: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_member_communication
          ? this.activeStaffPermission.can_do_templated_member_communication
          : false
  ],
      can_see_reports_finance: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_finance
          ? this.activeStaffPermission.can_see_reports_finance
          : false
  ],
      can_see_reports_clients: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_clients
          ? this.activeStaffPermission.can_see_reports_clients
          : false
  ],
      can_see_reports_operational: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_operational
          ? this.activeStaffPermission.can_see_reports_operational
          : false
  ],

      can_see_reports_appointment: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_appointment
          ? this.activeStaffPermission.can_see_reports_appointment
          : false
  ],

      can_see_reports_class: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_class
          ? this.activeStaffPermission.can_see_reports_class
          : false
  ],
      can_see_reports_sales: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_sales
          ? this.activeStaffPermission.can_see_reports_sales
          : false
  ],
      can_see_reports_staff: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_staff
          ? this.activeStaffPermission.can_see_reports_staff
          : false
  ],

      can_see_reports_marketing: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_marketing
          ? this.activeStaffPermission.can_see_reports_marketing
          : false
  ],
      can_see_reports_security: [
        this.staffPermissionId && this.activeStaffPermission.can_see_reports_security
          ? this.activeStaffPermission.can_see_reports_security
          : false
  ],
      can_export_reports: [
        this.staffPermissionId && this.activeStaffPermission.can_export_reports
          ? this.activeStaffPermission.can_export_reports
          : false
  ],

      can_export_report_with_sensetive_info: [
        this.staffPermissionId && this.activeStaffPermission.can_export_report_with_sensetive_info
          ? this.activeStaffPermission.can_export_report_with_sensetive_info
          : false
  ],
      can_manage_staff: [
        this.staffPermissionId && this.activeStaffPermission.can_manage_staff
          ? this.activeStaffPermission.can_manage_staff
          : false
  ],

      can_admin_staff: [
        this.staffPermissionId && this.activeStaffPermission.can_admin_staff
          ? this.activeStaffPermission.can_admin_staff
          : false
  ],

      // can_manage_staff_permission_template:[
      //   this.staffPermissionId && this.activeStaffPermission.can_manage_staff_permission_template
      //     ? this.activeStaffPermission.can_manage_staff_permission_template
      //     : false,
      // ],
      single_staff_discount: [
        this.staffPermissionId && this.activeStaffPermission.single_staff_discount
          ? this.activeStaffPermission.single_staff_discount
          : 0
  ],
      recurring_staff_discount: [
        this.staffPermissionId && this.activeStaffPermission.recurring_staff_discount
          ? this.activeStaffPermission.recurring_staff_discount
          : 0
  ],
      can_do_billing_at_other_tenant: [
        this.staffPermissionId && this.activeStaffPermission.can_do_billing_at_other_tenant
          ? this.activeStaffPermission.can_do_billing_at_other_tenant
          : false
  ],
      can_get_sdr_contact: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_contact
          ? this.activeStaffPermission.can_get_sdr_contact
          : false
  ],
      can_get_sdr_subscription: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_subscription
          ? this.activeStaffPermission.can_get_sdr_subscription
          : false
  ],
      can_get_sdr_leadbystaff: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_leadbystaff
          ? this.activeStaffPermission.can_get_sdr_leadbystaff
          : false
  ],
      can_get_sdr_leadbychannel: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_leadbychannel
          ? this.activeStaffPermission.can_get_sdr_leadbychannel
          : false
  ],
      can_get_sdr_leadbysource: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_leadbysource
          ? this.activeStaffPermission.can_get_sdr_leadbysource
          : false
  ],
      can_get_sdr_tourbooked: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_tourbooked
          ? this.activeStaffPermission.can_get_sdr_tourbooked
          : false
  ],
      can_get_sdr_tourattended: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_tourattended
          ? this.activeStaffPermission.can_get_sdr_tourattended
          : false
  ],
      can_get_sdr_trial: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_trial
          ? this.activeStaffPermission.can_get_sdr_trial
          : false
  ],
      can_get_sdr_subscription_by_source: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_subscription_by_source
          ? this.activeStaffPermission.can_get_sdr_subscription_by_source
          : false
  ],
      can_get_sdr_subscription_by_channel: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_subscription_by_channel
          ? this.activeStaffPermission.can_get_sdr_subscription_by_channel
          : false
  ],
      can_get_sdr_subscription_signupcount: [
        this.staffPermissionId && this.activeStaffPermission.can_get_sdr_subscription_signupcount
          ? this.activeStaffPermission.can_get_sdr_subscription_signupcount
          : false
  ],
    });
    this.staffPermissionForm.valueChanges.pipe(debounce(() => interval(200))).subscribe((value: any) => {
      this.formChange.emit(true);
    })

    this.initializeClientControl();
    this.initializeClientCommunication();
    this.initializeClientScheduling();
    this.initializeClientBillingAndFinance();
    this.initializeClientReporting();
    this.initializeSalesDayEndReportControl();

    this.cd.detectChanges();
  }

  get SingleStaffDiscount(): AbstractControl | null {
    return this.staffPermissionForm.get('single_staff_discount')
  }
  get RecurringStaffDiscount(): AbstractControl | null {
    return this.staffPermissionForm.get('recurring_staff_discount')
  }

  
  initializeClientControl() {
    let temp = false;
    if (this.staffPermissionForm.get('can_do_client_profiles')?.value
      && this.staffPermissionForm.get('can_manage_client_profiles')?.value
      && this.staffPermissionForm.get('can_do_member_communication')?.value
      && this.staffPermissionForm.get('can_manage_member_communication')?.value
      && this.staffPermissionForm.get('can_admin_member_communication')?.value
      && this.staffPermissionForm.get('can_admin_client_profiles')?.value
      && this.staffPermissionForm.get('can_do_templated_member_communication')?.value
      && this.staffPermissionForm.get('can_do_free_form_manage_member_communication')?.value
    ) {
      temp = true
    }
    this.staffPermissionForm.addControl("clientControl", new UntypedFormControl(temp))
    this.staffPermissionForm.get('clientControl')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_do_client_profiles')?.setValue(true);
          this.staffPermissionForm.get('can_manage_client_profiles')?.setValue(true);
          this.staffPermissionForm.get('can_do_member_communication')?.setValue(true);
          this.staffPermissionForm.get('can_manage_member_communication')?.setValue(true);
          this.staffPermissionForm.get('can_admin_member_communication')?.setValue(true);
          this.staffPermissionForm.get('can_admin_client_profiles')?.setValue(true);
          this.staffPermissionForm.get('can_do_templated_member_communication')?.setValue(true);
          this.staffPermissionForm.get('can_do_free_form_manage_member_communication')?.setValue(true);

        } else {
          this.staffPermissionForm.get('can_do_client_profiles')?.setValue(false);
          this.staffPermissionForm.get('can_manage_client_profiles')?.setValue(false);
          this.staffPermissionForm.get('can_do_member_communication')?.setValue(false);
          this.staffPermissionForm.get('can_manage_member_communication')?.setValue(false);
          this.staffPermissionForm.get('can_admin_member_communication')?.setValue(false);
          this.staffPermissionForm.get('can_admin_client_profiles')?.setValue(false);
          this.staffPermissionForm.get('can_do_templated_member_communication')?.setValue(false);
          this.staffPermissionForm.get('can_do_free_form_manage_member_communication')?.setValue(false);
        }
      }
    })
  }

  initializeClientCommunication() {

    let temp = false;
    if (this.staffPermissionForm.get('can_manage_membership_basic')?.value
      && this.staffPermissionForm.get('can_admin_membership')?.value
      && this.staffPermissionForm.get('can_manage_staff')?.value
      && this.staffPermissionForm.get('can_admin_staff')?.value
      //&& this.staffPermissionForm.get('can_manage_staff_permission_template')?.value
    ) {
      temp = true
    }
    this.staffPermissionForm.addControl("clientCommunication", new UntypedFormControl(temp))
    this.staffPermissionForm.get('clientCommunication')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_manage_membership_basic')?.setValue(true);
          this.staffPermissionForm.get('can_admin_membership')?.setValue(true);
          this.staffPermissionForm.get('can_manage_staff')?.setValue(true);
          this.staffPermissionForm.get('can_admin_staff')?.setValue(true);
          //this.staffPermissionForm.get('can_manage_staff_permission_template')?.setValue(true);
        } else {
          this.staffPermissionForm.get('can_manage_membership_basic')?.setValue(false);
          this.staffPermissionForm.get('can_admin_membership')?.setValue(false);
          this.staffPermissionForm.get('can_manage_staff')?.setValue(false);
          this.staffPermissionForm.get('can_admin_staff')?.setValue(false);
          //this.staffPermissionForm.get('can_manage_staff_permission_template')?.setValue(false);
        }
      }
    })
  }

  initializeClientScheduling() {
    let temp = false;
    if (this.staffPermissionForm.get('can_manage_appointments')?.value
      && this.staffPermissionForm.get('can_manage_class')?.value
      && this.staffPermissionForm.get('can_admin_class')?.value
      && this.staffPermissionForm.get('can_admin_appointments')?.value
    ) {
      temp = true
    }

    this.staffPermissionForm.addControl("scheduling", new UntypedFormControl(temp))
    this.staffPermissionForm.get('scheduling')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_manage_appointments')?.setValue(true);
          this.staffPermissionForm.get('can_manage_class')?.setValue(true);
          this.staffPermissionForm.get('can_admin_class')?.setValue(true);
          this.staffPermissionForm.get('can_admin_appointments')?.setValue(true);
        } else {
          this.staffPermissionForm.get('can_manage_appointments')?.setValue(false);
          this.staffPermissionForm.get('can_manage_class')?.setValue(false);
          this.staffPermissionForm.get('can_admin_class')?.setValue(false);
          this.staffPermissionForm.get('can_admin_appointments')?.setValue(false);
        }
      }
    })
  }

  initializeClientBillingAndFinance() {
    let temp = false;
    if (this.staffPermissionForm.get('can_do_billing')?.value
      && this.staffPermissionForm.get('can_admin_billing')?.value
    ) {
      temp = true
    }
    this.staffPermissionForm.addControl("billingAndFinance", new UntypedFormControl(temp))
    this.staffPermissionForm.get('billingAndFinance')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_do_billing')?.setValue(true);
          this.staffPermissionForm.get('can_admin_billing')?.setValue(true);
        } else {
          this.staffPermissionForm.get('can_do_billing')?.setValue(false);
          this.staffPermissionForm.get('can_admin_billing')?.setValue(false);
        }
      }
    })

    if (this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.value || this.staffPermissionForm.get('can_do_billing')?.value)
    {
      this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.enable({onlySelf:true});
    }
    else{
      this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.disable({onlySelf:true});
    }

    this.staffPermissionForm.get('can_do_billing')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.enable({onlySelf:true});
        } else {
          this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.disable({onlySelf:true});
          this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.setValue(false);
        }
      }
    })

    this.staffPermissionForm.get('can_do_billing_at_other_tenant')?.updateValueAndValidity();
  }

  initializeClientReporting() {
    let temp = false;
    if (this.staffPermissionForm.get('can_see_reports_finance')?.value
      && this.staffPermissionForm.get('can_see_reports_clients')?.value
      && this.staffPermissionForm.get('can_see_reports_operational')?.value
      && this.staffPermissionForm.get('can_see_reports_appointment')?.value

      && this.staffPermissionForm.get('can_see_reports_class')?.value
      && this.staffPermissionForm.get('can_see_reports_sales')?.value
      && this.staffPermissionForm.get('can_see_reports_staff')?.value
      && this.staffPermissionForm.get('can_see_reports_marketing')?.value

      && this.staffPermissionForm.get('can_see_reports_security')?.value
      && this.staffPermissionForm.get('can_export_reports')?.value
      && this.staffPermissionForm.get('can_export_report_with_sensetive_info')?.value
    ) {
      temp = true
    }

    this.staffPermissionForm.addControl("reporting", new UntypedFormControl(temp))
    this.staffPermissionForm.get('reporting')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_see_reports_finance')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_clients')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_operational')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_appointment')?.setValue(true);

          this.staffPermissionForm.get('can_see_reports_class')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_sales')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_staff')?.setValue(true);
          this.staffPermissionForm.get('can_see_reports_marketing')?.setValue(true);

          this.staffPermissionForm.get('can_see_reports_security')?.setValue(true);
          this.staffPermissionForm.get('can_export_reports')?.setValue(true);
          this.staffPermissionForm.get('can_export_report_with_sensetive_info')?.setValue(true);

        } else {
          this.staffPermissionForm.get('can_see_reports_finance')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_clients')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_operational')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_appointment')?.setValue(false);

          this.staffPermissionForm.get('can_see_reports_class')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_sales')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_staff')?.setValue(false);
          this.staffPermissionForm.get('can_see_reports_marketing')?.setValue(false);

          this.staffPermissionForm.get('can_see_reports_security')?.setValue(false);
          this.staffPermissionForm.get('can_export_reports')?.setValue(false);
          this.staffPermissionForm.get('can_export_report_with_sensetive_info')?.setValue(false);
        }
      }
    })
  }

  initializeSalesDayEndReportControl() {
    let temp = false;
    if (this.staffPermissionForm.get('can_get_sdr_contact')?.value
      || this.staffPermissionForm.get('can_get_sdr_subscription')?.value
      || this.staffPermissionForm.get('can_get_sdr_leadbystaff')?.value
      || this.staffPermissionForm.get('can_get_sdr_leadbychannel')?.value
      || this.staffPermissionForm.get('can_get_sdr_leadbysource')?.value
      || this.staffPermissionForm.get('can_get_sdr_tourbooked')?.value
      || this.staffPermissionForm.get('can_get_sdr_tourattended')?.value
      || this.staffPermissionForm.get('can_get_sdr_trial')?.value
      || this.staffPermissionForm.get('can_get_sdr_subscription_by_source')?.value
      || this.staffPermissionForm.get('can_get_sdr_subscription_by_channel')?.value
      || this.staffPermissionForm.get('can_get_sdr_subscription_signupcount')?.value
    ) {
      temp = true
    }
    this.staffPermissionForm.addControl("sales_day_end_report", new UntypedFormControl(temp))
    this.staffPermissionForm.get('sales_day_end_report')?.valueChanges.subscribe({
      next: (value: any) => {
        if (value) {
          this.staffPermissionForm.get('can_get_sdr_contact')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_subscription')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_leadbystaff')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_leadbychannel')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_leadbysource')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_tourbooked')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_tourattended')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_trial')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_subscription_by_source')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_subscription_by_channel')?.setValue(true);
          this.staffPermissionForm.get('can_get_sdr_subscription_signupcount')?.setValue(true);
        } else {
          this.staffPermissionForm.get('can_get_sdr_contact')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_subscription')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_leadbystaff')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_leadbychannel')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_leadbysource')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_tourbooked')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_tourattended')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_trial')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_subscription_by_source')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_subscription_by_channel')?.setValue(false);
          this.staffPermissionForm.get('can_get_sdr_subscription_signupcount')?.setValue(false);
        }
      }
    });
  }

  get Name(): AbstractControl | null {
    return this.staffPermissionForm.get('name');
  }
  get Description(): AbstractControl | null {
    return this.staffPermissionForm.get('description');
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes?.saveForm?.currentValue) {
      this.saveStaffPermission();
    }
    // You can also use categoryId.previousValue and
    // categoryId.firstChange for comparing old and new values

  }


  saveStaffPermission() {
    if (this.staffPermissionForm.valid) {
      const rawValue = this.staffPermissionForm.getRawValue();
      delete rawValue.sales_day_end_report;
      
      this.staffPermissionForm.addControl("clientControl", new UntypedFormControl(false))
      if (rawValue.clientControl != undefined)
        delete rawValue.clientControl

      if (rawValue.clientCommunication != undefined)
        delete rawValue.clientCommunication

      if (rawValue.scheduling != undefined)
        delete rawValue.scheduling

      if (rawValue.billingAndFinance != undefined)
        delete rawValue.billingAndFinance

      if (rawValue.reporting != undefined)
        delete rawValue.reporting
      this.isFormSubmitting = true;
      if (this.staffPermissionId) {
        this.claimService
          .updateTemplate(this.staffPermissionId, rawValue)
          .subscribe({
            next: (res: any) => {
              this.isFormSubmitting = false;
              this.translate
                .get([
                  'ADMIN.STAFF_PERMISSION.UPDATED',
                  'ADMIN.STAFF_PERMISSION.UPDATED_MESSAGE'
  ])
                .subscribe((translations) => {
                  this.toastMessageService.showSuccess(translations);
                });
              this.modified.emit(res);
              this.cd.detectChanges();
            },
            error: (error) => {
              this.isFormSubmitting = false;
              this.toastMessageService.showError(error);
              this.cd.detectChanges();
            },
          });
      } else {
        this.claimService
          .createTemplate(rawValue)
          .subscribe({
            next: (res: any) => {
              this.isFormSubmitting = false;
              this.translate
                .get([
                  'ADMIN.STAFF_PERMISSION.CREATED',
                  'ADMIN.STAFF_PERMISSION.CREATED_MESSAGE'
  ])
                .subscribe((translations) => {
                  this.toastMessageService.showSuccess(translations);
                });
              this.modified.emit(res);
              this.cd.detectChanges();
            },
            error: (error) => {
              this.isFormSubmitting = false;
              this.toastMessageService.showError(error);
              this.cd.detectChanges();
            },
          });
      }
    } else {
      Object.keys(this.staffPermissionForm.controls).forEach((field) => {
        const control = this.staffPermissionForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      return;
    }
  }

  handleError(error: any) {
    if (error instanceof NotFoundError) {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'common.errors.SERVER_SIDE.PAGE_NOT_FOUND'
  ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    } else if (error.originalError && error.originalError.error) {
      let duplicate = false;
      error.originalError?.error.forEach((err: any) => {
        if (err.errorCode == 'Duplicate_Value') {
          this.staffPermissionForm.controls['name_primary_language'].setErrors({
            duplicate: true,
          });

          this.staffPermissionForm.controls['name_secondary_language'].setErrors({
            duplicate: true,
          });
          duplicate = true;
        }
      });
      // Show only form error if there is duplicate entry
      if (duplicate) return;
    } else {
      this.translate
        .get([
          'common.errors.SERVER_SIDE.ERROR_OCCURRED',
          'common.errors.SERVER_SIDE.SOMETHING_WRONG'
  ])
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    }
    this.extractErrorMessages(error);
    this.showErrorPopup$?.next(true);
    this.cd.detectChanges();
  }

  extractErrorMessages(error: any) {
    error?.originalError?.error.forEach((item: any) => {
      if (item.errorMessage) this.errorMessages.push(item.errorMessage);
    });
    if (error?.originalError?.message) {
      this.errorMessages.push(error?.originalError?.message);
    }
    if (Array.isArray(error)) {
      error.forEach((item: any) => {
        this.errorMessages.push(item.errorMessage);
      });
    }
  }
}
